/* esm.sh - @radix-ui/react-dismissable-layer@1.1.11 */
export * from "/*@radix-ui/react-dismissable-layer@1.1.11/esnext/react-dismissable-layer.mjs";
